import {AlertIcon} from '@primer/octicons-react'
import {Flash} from '@primer/react'

import styles from './WarningBanner.module.css'

export function OrgsFailedToLoadBanner() {
  return (
    <Flash className={styles.ssoWarningBanner} variant="warning">
      <AlertIcon size={16} className={styles.alertIcon} />
      <span>Some threads failed to load. Please refresh the page to try again.</span>
    </Flash>
  )
}
